import React from "react";

export default function Unauthorized() {
  return <div>Unauthorized</div>;
}
